import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, Toast } from '../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  private readonly svc = inject(ToastService);
  readonly toasts = this.svc.toasts;

  trackById(_i: number, t: Toast): number { return t.id; }

  dismiss(id: number): void {
    this.svc.dismiss(id);
  }
}
